<template>
  <div>
    <el-button
      :icon="collapse ? 'el-icon-s-unfold':'el-icon-s-fold'"
      circle
      type="default"
      @click="collapse = !collapse"
    ></el-button>

    <div class="justify-middle" style="float:right;height:60px;">
      <el-avatar :size="45">U</el-avatar>
      <el-popover>
        <el-link type="text" class="link" slot="reference">
          {{$store.getters.user.username}}
          <i
            :class="menuActive ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          ></i>
        </el-link>
        <el-button style="width:100%" @click="logout">登出</el-button>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  props: { value: { type: Boolean, defualt: false } },
  data() {
    return {
      menuActive: false,
      collapse: this.value
    };
  },
  watch: {
    collapse(newVal) {
      this.$emit("input", newVal);
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("FedLogOut");
      this.$router.push({ path: "/login" });
    }
  }
};
</script>

<style>
.justify-middle {
  display: flex;
  align-items: center;
  justify-content: center;
}
.justify-middle .link {
  margin-left: 10px;
  font-size: 16px;
}
</style>